import { Box } from '@tempmee/react';
import { CenteredSpinner , DataGrid, Pagination } from '~/commonComponents';
import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router';
import { DashboardJobsStatus, DashboardJobsType, IDashboardJob } from '~/domain/DashboardJobs';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { FilterStatusEnum } from '~/utils/Enum';
import { useJobList } from '../../hooks';
import { DataGridCommonColumn } from '../DataGrid.column';
import { EmptyMessage } from '../EmptyMessage';

interface IOpenTabProps {
  jobType: DashboardJobsType;
}

export const OpenTab = ({ jobType }: IOpenTabProps) => {
  const navigate = useNavigate();

  const isEnforcePermanentJobV2 = useRef(getShouldEnforcePermanentJobV2()).current;

  const { data, isInitialLoading, isLoading, methods, pagination } = useJobList({
    status: DashboardJobsStatus.OPEN,
    jobType,
  });

  const handleRowClick = useCallback(
    (item: IDashboardJob) => {
      navigate(`/dashboard/job/${item.id}`);
    },
    [navigate],
  );

  if (isInitialLoading) {
    return (
      <Box style={{ marginTop: 32 }}>
        <CenteredSpinner />
      </Box>
    );
  }

  return (
    <DataGrid
      EmptyComponent={<EmptyMessage type={FilterStatusEnum.OPEN} />}
      PaginationComponent={
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={methods.setCurrentPage}
          maxButtons={5}
        />
      }
      columns={[
        DataGridCommonColumn.Office,
        ...(isEnforcePermanentJobV2
          ? [
              {
                ...DataGridCommonColumn.Type,
                width: '180px',
              },
            ]
          : []),
        DataGridCommonColumn.Details,
        DataGridCommonColumn.Profession,
        DataGridCommonColumn.Rate,
        DataGridCommonColumn.Invite,
        DataGridCommonColumn.Action,
      ]}
      data={data}
      dataCy={{
        root: 'open-shifts-grid',
        header: 'open-shifts-grid-header',
        rowItem: 'open-shifts-grid-row',
      }}
      isLoading={isLoading}
      keyExtractor={(item) => item.id}
      onRowClick={handleRowClick}
    />
  );
};
